/** Konsisten texture key — ganti PNG asli cukup load dengan key yang sama di PreloadScene */
export const TEXTURE_KEYS = {
  // Karakter utama
  PLAYER_IDLE_0: 'player_idle_0',
  PLAYER_IDLE_1: 'player_idle_1',
  PLAYER_WALK_0: 'player_walk_0',
  PLAYER_WALK_1: 'player_walk_1',
  PLAYER_WALK_2: 'player_walk_2',
  PLAYER_WALK_3: 'player_walk_3',

  // NPC
  KAKEK_SAKTI: 'npc_kakek_sakti',
  IBUNDO: 'npc_ibundo',
  LANSIA: 'npc_lansia',
  IBU_HAMIL: 'npc_ibu_hamil',
  WARGA: 'npc_warga',
  PETUGAS: 'npc_petugas',
  KERA: 'npc_kera',
  HARIMAU: 'npc_harimau',

  // Environment
  TREE_LARGE: 'env_tree_large',
  TREE_FALLEN: 'env_tree_fallen',
  GROUND_CRACK: 'env_ground_crack',
  RAFFLESIA: 'env_rafflesia',
  KERIS_1: 'env_keris_1',
  KERIS_2: 'env_keris_2',
  KERIS_3: 'env_keris_3',
  HOUSE_BUBUNGAN: 'env_house_bubungan',
  SIGN_BOARD: 'env_sign_board',
  PATH_RIVER: 'env_path_river',
  PATH_HILL: 'env_path_hill',
  SAFE_GATHERING: 'env_safe_gathering',

  // Background
  BG_MENU: 'bg_menu',
  BG_ZONE1: 'bg_zone1',
  BG_ZONE2: 'bg_zone2',
  BG_ZONE3: 'bg_zone3',
  BG_ZONE4: 'bg_zone4',
  BG_ZONE5: 'bg_zone5',
  BG_ENDING: 'bg_ending',

  // UI
  UI_BUTTON: 'ui_button',
  UI_DIALOGUE: 'ui_dialogue',
  UI_QUEST: 'ui_quest_panel',
  ICON_RAFFLESIA: 'ui_icon_rafflesia',
} as const;

export const ANIM_KEYS = {
  PLAYER_IDLE: 'player_idle',
  PLAYER_WALK: 'player_walk',
} as const;

export type TextureKey = (typeof TEXTURE_KEYS)[keyof typeof TEXTURE_KEYS];

export const ALL_TEXTURE_KEYS: TextureKey[] = Object.values(TEXTURE_KEYS);

export const CHARACTER_TEXTURES: TextureKey[] = [
  TEXTURE_KEYS.PLAYER_IDLE_0,
  TEXTURE_KEYS.PLAYER_IDLE_1,
  TEXTURE_KEYS.PLAYER_WALK_0,
  TEXTURE_KEYS.PLAYER_WALK_1,
  TEXTURE_KEYS.PLAYER_WALK_2,
  TEXTURE_KEYS.PLAYER_WALK_3,
  TEXTURE_KEYS.KAKEK_SAKTI,
  TEXTURE_KEYS.IBUNDO,
  TEXTURE_KEYS.LANSIA,
  TEXTURE_KEYS.IBU_HAMIL,
  TEXTURE_KEYS.WARGA,
  TEXTURE_KEYS.PETUGAS,
  TEXTURE_KEYS.KERA,
  TEXTURE_KEYS.HARIMAU,
];

export const ENVIRONMENT_TEXTURES: TextureKey[] = [
  TEXTURE_KEYS.TREE_LARGE,
  TEXTURE_KEYS.TREE_FALLEN,
  TEXTURE_KEYS.GROUND_CRACK,
  TEXTURE_KEYS.RAFFLESIA,
  TEXTURE_KEYS.KERIS_1,
  TEXTURE_KEYS.KERIS_2,
  TEXTURE_KEYS.KERIS_3,
  TEXTURE_KEYS.HOUSE_BUBUNGAN,
  TEXTURE_KEYS.SIGN_BOARD,
  TEXTURE_KEYS.PATH_RIVER,
  TEXTURE_KEYS.PATH_HILL,
  TEXTURE_KEYS.SAFE_GATHERING,
  TEXTURE_KEYS.BG_MENU,
  TEXTURE_KEYS.BG_ZONE1,
  TEXTURE_KEYS.BG_ZONE2,
  TEXTURE_KEYS.BG_ZONE3,
  TEXTURE_KEYS.BG_ZONE4,
  TEXTURE_KEYS.BG_ZONE5,
  TEXTURE_KEYS.BG_ENDING,
];

export const UI_TEXTURES: TextureKey[] = [
  TEXTURE_KEYS.UI_BUTTON,
  TEXTURE_KEYS.UI_DIALOGUE,
  TEXTURE_KEYS.UI_QUEST,
  TEXTURE_KEYS.ICON_RAFFLESIA,
];
